import { Button, Modal } from "@/components";
import { ModalTexts } from "@/resources/locale";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

import { useAppDispatch, useAppSelector } from "@/redux/store";
import { closeFeedbackModal } from "@/redux/feedback/slice";
import { FeedbackForm } from "../Forms/FeedbackForm";
import feedbackSuccessSend from "@/assets/img/feedbackSuccessSend.png";
import styles from "./ModalFeedback.module.scss";
import { useNavigate } from "react-router-dom";

export const ModalFeedback = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const windowWidth = useCurrentWidth();

  const { isOpen, isOpenSuccessModal } = useAppSelector(state => state.feedback);

  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;
  const modalTitle = isMobile ? "Обратная связь" : ModalTexts.feedback.TITLE;

  const modalSuccessTitle = isMobile ? "Обратная связь" : ModalTexts.feedbackSuccess.TITLE;
  const modalSuccessDescription = isMobile ? "" : ModalTexts.feedbackSuccess.SUB_TITLE;

  const handleCloseFeedbackModal = () => {
    dispatch(closeFeedbackModal());
  }

  const handleCloseSuccessModal = () => {
    dispatch(closeFeedbackModal());
    navigate("/");
  }

  return (
    <>
      <Modal
        title={modalTitle}
        isOpen={isOpen}
        setIsOpen={handleCloseFeedbackModal}
        closeModal={handleCloseFeedbackModal}
      >
        <FeedbackForm />
      </Modal>

      <Modal
        title={modalSuccessTitle}
        subTitle={modalSuccessDescription}
        isOpen={isOpenSuccessModal}
        setIsOpen={handleCloseFeedbackModal}
        closeModal={handleCloseFeedbackModal}
      >
        <img src={feedbackSuccessSend} alt="feedback success send" className={styles.image} />
        {!isMobile && (
          <Button onClickFunc={handleCloseSuccessModal}>
            Арендовать корт
          </Button>
        )}
        {
          isMobile && (
            <div className={styles.mobileContainer}>
              <p className={styles.mobileTitle}>
                Сообщение отправлено!
              </p>
              <p className={styles.mobileDescription}>
                {ModalTexts.feedbackSuccess.SUB_TITLE}
              </p>
            </div>
          )
        }
      </Modal>
    </>
  );
};